__turbopack_context__.v({
  "className": "geist_mono_925765a0-module__DdORAq__className",
});
